import "./Cauldron.css";

const Cauldron = () => (
  <div className="hero__ant hero__cauldron" role="img" aria-label="Lab flask cooking with flames">
    <svg className="hero__cauldron-svg" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="hc-heat" cx="50%" cy="80%" r="65%">
          <stop offset="0%" stopColor="#ffb347" stopOpacity="0.35" />
          <stop offset="55%" stopColor="#ff5a1f" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#150904" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="hc-liquid" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,229,138,0.55)" />
          <stop offset="55%" stopColor="rgba(255,138,43,0.5)" />
          <stop offset="100%" stopColor="rgba(196,58,16,0.55)" />
        </linearGradient>
        <linearGradient id="hc-glass" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.08)" />
          <stop offset="50%" stopColor="rgba(255,255,255,0.02)" />
          <stop offset="100%" stopColor="rgba(0,0,0,0.12)" />
        </linearGradient>
        <linearGradient id="hc-glassShine" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.35)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
        <linearGradient id="hc-glassDepth" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
          <stop offset="40%" stopColor="rgba(255,255,255,0)" />
          <stop offset="80%" stopColor="rgba(0,0,0,0)" />
          <stop offset="100%" stopColor="rgba(0,0,0,0.25)" />
        </linearGradient>
        <radialGradient id="hc-floor" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ff7a1f" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#ff7a1f" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="hc-flameBody" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#3a80ff" stopOpacity="0.55" />
          <stop offset="8%" stopColor="#c43a10" stopOpacity="0.95" />
          <stop offset="35%" stopColor="#ff5a1f" />
          <stop offset="65%" stopColor="#ffb347" />
          <stop offset="90%" stopColor="#ffe58a" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#fff5d0" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="hc-flameCore" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#ffe58a" stopOpacity="0.9" />
          <stop offset="50%" stopColor="#fff5d0" />
          <stop offset="100%" stopColor="#fff5d0" stopOpacity="0" />
        </linearGradient>
        <radialGradient id="hc-flameHaze" cx="50%" cy="65%" r="55%">
          <stop offset="0%" stopColor="#ffb347" stopOpacity="0.6" />
          <stop offset="55%" stopColor="#ff5a1f" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#c43a10" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="hc-coals" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffe58a" />
          <stop offset="35%" stopColor="#ff7a1f" />
          <stop offset="75%" stopColor="#c43a10" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#3a0f05" stopOpacity="0" />
        </radialGradient>
        <clipPath id="hc-liquid-clip">
          <path d="M 98 92 L 62 168 Q 60 182 76 182 L 144 182 Q 160 182 158 168 L 122 92 Z" />
        </clipPath>
      </defs>

      <rect x="0" y="0" width="220" height="220" fill="url(#hc-heat)" />

      <ellipse cx="110" cy="196" rx="70" ry="10" fill="url(#hc-floor)" className="hc-floor" />

      <g className="hc-flask">
        <path d="M 98 50 L 98 92 L 62 168 Q 60 182 76 182 L 144 182 Q 160 182 158 168 L 122 92 L 122 50 Z"
              fill="url(#hc-glass)" stroke="rgba(255,210,140,0.32)" strokeWidth="1.2" strokeLinejoin="round" />
        <path d="M 98 50 L 98 92 L 62 168 Q 60 182 76 182 L 144 182 Q 160 182 158 168 L 122 92 L 122 50 Z"
              fill="url(#hc-glassDepth)" />
        <rect x="94" y="44" width="32" height="8" rx="3" fill="rgba(255,210,140,0.1)" stroke="rgba(255,210,140,0.4)" strokeWidth="1" />
        <path d="M 100 55 L 100 90 Q 96 98 76 162" stroke="url(#hc-glassShine)" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
        <ellipse cx="100" cy="170" rx="3" ry="10" fill="rgba(255,255,255,0.18)" />

        <g clipPath="url(#hc-liquid-clip)">
          <rect x="50" y="128" width="130" height="60" fill="url(#hc-liquid)" />
          <path className="hc-wave" d="M 50 130 Q 75 124 100 130 T 150 130 T 200 130 L 200 140 L 50 140 Z"
                fill="rgba(255,240,190,0.28)" />
          <ellipse cx="110" cy="128" rx="45" ry="2.5" fill="rgba(255,245,200,0.45)" className="hc-shimmer" />
          <ellipse cx="78" cy="170" rx="4" ry="14" fill="rgba(255,255,255,0.2)" />
        </g>

        <circle className="hc-bubble hc-b1" cx="95" cy="170" r="3.2" fill="rgba(255,245,208,0.85)" />
        <circle className="hc-bubble hc-b2" cx="118" cy="172" r="2.2" fill="rgba(255,245,208,0.8)" />
        <circle className="hc-bubble hc-b3" cx="108" cy="168" r="2.6" fill="rgba(255,245,208,0.82)" />
        <circle className="hc-bubble hc-b4" cx="130" cy="170" r="1.8" fill="rgba(255,245,208,0.78)" />
      </g>

      <g className="hc-smoke">
        <circle className="hc-puff hc-p1" cx="108" cy="38" r="7" fill="rgba(200,215,235,0.18)" />
        <circle className="hc-puff hc-p2" cx="116" cy="28" r="9" fill="rgba(200,215,235,0.14)" />
        <circle className="hc-puff hc-p3" cx="104" cy="18" r="11" fill="rgba(200,215,235,0.1)" />
        <circle className="hc-puff hc-p4" cx="118" cy="8" r="13" fill="rgba(200,215,235,0.06)" />
      </g>

      <g className="hc-chemist">
        <g transform="translate(122 46)">
          <g className="hc-tube" transform="rotate(-55)">
            <rect x="-2.2" y="-13" width="4.4" height="14" rx="1.6"
                  fill="rgba(220,235,255,0.28)" stroke="#a86b14" strokeWidth="0.55" />
            <rect x="-1.7" y="-7" width="3.4" height="7" fill="#7fcf3f" />
            <ellipse cx="0" cy="-7" rx="1.7" ry="0.5" fill="#bff080" />
            <rect x="-2.6" y="-14" width="5.2" height="1.6" rx="0.5" fill="#a86b14" />
          </g>
          <ellipse cx="6" cy="2" rx="4.2" ry="3" fill="#5a2a08" />
          <ellipse cx="1.5" cy="1" rx="2.6" ry="2.1" fill="#5a2a08" />
          <ellipse cx="-3" cy="0" rx="2.9" ry="2.4" fill="#5a2a08" />
          <circle cx="-4.3" cy="-0.6" r="0.65" fill="#ffd166" />
          <path d="M -4 -1.8 Q -6 -4.5 -7.5 -5.5 M -3 -2.2 Q -4 -4.5 -4.5 -6"
                stroke="#3a1a05" strokeWidth="0.55" fill="none" strokeLinecap="round" />
          <path d="M 1.5 2.5 L 0 7 M 3 2.5 L 4.5 7 M 5 2.5 L 7 7 M 7 2.5 L 9 7"
                stroke="#3a1a05" strokeWidth="0.7" strokeLinecap="round" fill="none" />
          <path d="M -1.5 -1 L 0.5 -5.5 M -2.5 -1 L -0.5 -4.5"
                stroke="#3a1a05" strokeWidth="0.8" strokeLinecap="round" fill="none" />
        </g>
        <circle className="hc-drop hc-d1" cx="111" cy="40" r="1.3" fill="#7fcf3f" />
        <circle className="hc-drop hc-d2" cx="111" cy="40" r="1" fill="#9fdf5f" />
        <circle className="hc-drop hc-d3" cx="111" cy="40" r="1.4" fill="#bff080" />
        <circle className="hc-drop hc-d4" cx="111" cy="40" r="0.9" fill="#7fcf3f" />
      </g>

      <circle className="hc-spark hc-s1" cx="70" cy="150" r="1.2" fill="#ffe58a" />
      <circle className="hc-spark hc-s2" cx="155" cy="140" r="1" fill="#ffd166" />
      <circle className="hc-spark hc-s3" cx="90" cy="100" r="0.9" fill="#fff5d0" />
      <circle className="hc-spark hc-s4" cx="140" cy="110" r="1.1" fill="#ffb347" />
    </svg>
  </div>
);

export default Cauldron;
